/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { HeatmapCell, Threshold } from './heatmap_types';

const MAX_LABEL_LEN = 10;

const labelFormatter = function(val: string) {
  let text;
  if (val.length <= MAX_LABEL_LEN) {
    text = val;
  } else {
    text = val.substring(0, MAX_LABEL_LEN - 3) + '...';
  }
  return text.toUpperCase();
};

const Axis = {
  type: 'category',
  data: [],
  nameLocation: 'center',
  nameTextStyle: {
    color: 'rgb(62, 70, 76)',
    fontSize: 14,
  },
  nameGap: 40,
  axisLabel: {
    formatter: labelFormatter,
    fontSize: 10,
    fontFamily: 'Lato',
    color: 'rgb(140, 155, 165)',
  },
  axisTick: {
    show: false,
  },
};

export default {
  tooltip: {
    position: 'top',
    triggerOn: 'mousemove',
    formatter: (params: any) => {
      return params.data.thresholdLabel;
    },
  },
  grid: {
    left: 40,
    top: 5,
    right: 5,
    bottom: 40,
    containLabel: true,
  },
  animation: false,
  xAxis: {
    ...Axis,
  },
  yAxis: {
    ...Axis,
    axisLabel: {
      ...Axis.axisLabel,
      rotate: 90,
    },
  },
  visualMap: {
    show: false,
    type: 'piecewise',
    pieces: <Threshold[]>[],
    precision: 2,
  },
  series: [
    {
      name: 'Risk value',
      type: 'heatmap',
      data: <HeatmapCell[]>[],
      label: {
        normal: {
          show: true,
          fontSize: 24,
          color: '#fff',
          formatter(val: any) {
            return val.data.label;
          },
        },
      },
      itemStyle: {
        borderWidth: 5,
        borderColor: 'white',
        emphasis: {
          borderColor: 'rgb(62, 70, 76)',
        },
      },
    },
    {
      name: 'Empty cells',
      type: 'heatmap',
      data: <HeatmapCell[]>[],
      label: {
        normal: { show: false },
      },
      silent: true,
      itemStyle: {
        borderWidth: 5,
        borderColor: 'white',
      },
    },
  ],
};
